

import React, { useState, useEffect } from "react";
import axios from "../api/axiosConfig";
import {
  Button, Box, Typography, Paper, Divider,
  Checkbox, Stack, Grid, Chip, IconButton,
  ToggleButton,
  Snackbar,
  Alert,
  useTheme,
  useMediaQuery
} from "@mui/material";
import MemberSelectModal from "../components/MemberSelectModal";
// import Layout from "../components/Layout";
import { getNamaBulan } from "../utils/DataHelper";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ContactPageIcon from "@mui/icons-material/ContactPage";
import SaveIcon from "@mui/icons-material/Save";
import PaymentResponse from "../components/PaymentResponse";

import { motion } from "framer-motion";



export default function PaymentTransaction() {
  const [hidden, setHidden] = useState(true);
  const [rows, setRows] = useState([]);
  // const [loading, setLoading] = useState(true);
  const [payResponModalOpen, setPayResponModalOpen] = useState(false);
  const [responPayment, setResponPayment] = useState(null);

  const [memberModalOpen, setMemberModalOpen] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);

  const [bills, setBills] = useState([]);
  const [selectedBills, setSelectedBills] = useState([]);


  const [submitting, setSubmitting] = useState(false);
  const [toast, setToast] = useState({
    open: false,
    severity: "success",
    message: "",
  });


  const fetchData = async () => {
    try {
      // setLoading(true);

      const resp = await axios.get(`/jemaat.php?isbetaniamember=1`);
      setRows(resp.data);
    } catch (err) {
      console.error("Error fetching member list:", err);
    } finally {
      // setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchBills = async (idjemaat) => {
    try {
      // setLoading(true);

      const resp = await axios.get(`/billingunpaid.php?membercode=${idjemaat}`);
      setBills(resp.data.data);
      setSelectedBills([]);
    } catch (err) {
      console.error("Error fetching bills:", err);
    } finally {
      // setLoading(false);
    }
  };

  const handleSelectMember = (m) => {
    setSelectedMember(m);
    fetchBills(m.idjemaat);
  };

  const toggleBill = (billId) => {
    setSelectedBills((prev) =>
      prev.includes(billId)
        ? prev.filter((cardcode) => cardcode !== billId)
        : [...prev, billId]
    );
  };

  const totalSelected = bills
    .filter((b) => selectedBills.includes(b.cardcode))
    .reduce((sum, b) => sum + Number(b.amount || 0), 0);

  const countSelected = bills
    .filter((b) => selectedBills.includes(b.cardcode))
    .reduce((sum, b) => sum + Number(1 || 0), 0);

  const handleSubmitPayment = async () => {
    if (!selectedBills.length) {
      setToast({
        open: true,
        severity: "warning",
        message: "Belum pilih tagihan.",
      });
      return;
    }

    console.log("Submitting payment for bills:", selectedBills);
    try {
      setSubmitting(true);
      const res = await axios.post("/paybilling.php", {
        cardcodes: selectedBills,
      });
      console.log('Respon Payment', res.data)
      setResponPayment(res.data)
      setPayResponModalOpen(true)
      fetchBills(selectedMember.idjemaat);
      setToast({
        open: true,
        severity: "success",
        message: "Pembayaran berhasil diproses.",
      });
    } catch (err) {
      console.error("Submit payment error:", err);
      setToast({
        open: true,
        severity: "error",
        message: "Gagal memproses pembayaran.",
      });
    } finally {
      setSubmitting(false);
    }
  };

  const visibleUnpaidBills = bills.filter(
    (b) => b.ispaid !== 1 && (!hidden || b.ispaid !== 1)
  );

  const isAllSelected =
    visibleUnpaidBills.length > 0 &&
    visibleUnpaidBills.every((b) => selectedBills.includes(b.cardcode));

  const handleToggleSelectAll = () => {
    if (isAllSelected) {
      // Clear all (yang visible & unpaid)
      setSelectedBills((prev) =>
        prev.filter(
          (code) =>
            !visibleUnpaidBills.some((b) => b.cardcode === code)
        )
      );
    } else {
      // Select all unpaid & visible
      const allCodes = visibleUnpaidBills.map((b) => b.cardcode);
      setSelectedBills((prev) => Array.from(new Set([...prev, ...allCodes])));
    }
  };


  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  const isXs = useMediaQuery(theme.breakpoints.only("xs"));
  const isSm = useMediaQuery(theme.breakpoints.only("sm"));
  const isMd = useMediaQuery(theme.breakpoints.only("md"));
  const isLg = useMediaQuery(theme.breakpoints.only("lg"));

  const screenSize =
    isXs ? "xs" :
      isSm ? "sm" :
        isMd ? "md" :
          isLg ? "lg" :
            "xl";

  return (
    <Box
      sx={{
        px: { xs: 1.5, md: 2.5 },
        height: {
          xs: "calc(100vh - 80px)",
          md: "calc(100vh - 19px)", // example: header taller on desktop
        },
        overflowY: "hidden",
        display: "flex",
        flexDirection: "column",
        background: isDark
          ? "linear-gradient(180deg, rgba(2,6,23,0.85), rgba(15,23,42,0.85))"
          : "linear-gradient(180deg, #f8fafc 0%, #eef2ff 100%)",
      }}
    >


      <Stack direction="row" alignItems="center" spacing={2} mb={1.5}>
        <Box>
          <Typography variant="h5" fontWeight={800}>
            Transaksi Pembayaran
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Kelola tagihan anggota dengan cepat dan akurat
          </Typography>
        </Box>
        <Box flex={1} />
        <Button
          variant="contained"
          onClick={() => setMemberModalOpen(true)}
          startIcon={<ContactPageIcon />}
          sx={{
            textTransform: "none",
            fontWeight: 700,
            borderRadius: 3,
            background: "linear-gradient(90deg,#2563eb,#1d4ed8)",
            boxShadow: "0 10px 22px rgba(37,99,235,0.28)",
          }}
        >
          Pilih Anggota
        </Button>
      </Stack>

      <Grid container spacing={2} sx={{}}>
        {/* HEADER*/}
        <Grid item size={{ xs: 12 }}
        >
          <Paper elevation={1}
            sx={{
              position: "sticky",
              top: 64,
              zIndex: 10,
              background: isDark
                ? "linear-gradient(145deg, rgba(15,23,42,0.95), rgba(2,6,23,0.98))"
                : "linear-gradient(145deg, #ffffff, #f1f5f9)",
              // border: "1px solid",
              borderColor: isDark ? "rgba(255,255,255,0.08)" : "#e2e8f0",
              boxShadow: isDark
                ? "0 12px 28px rgba(0,0,0,0.35)"
                : "0 8px 20px rgba(15,23,42,0.08)",
              px: 2, py: 1.5, borderRadius: 0
            }}>
            <Grid container spacing={1} width={'100%'}>
              <Grid item size={{ xs: 12, sm: 12, lg: 8 }} >
                <Stack direction="row" spacing={1} alignItems="center">
                  <Stack direction="column" spacing={1} sx={{ minWidth: 0 }}>
                    {selectedMember ? (
                      <Box sx={{ textAlign: "left" }} >
                        <Typography fontSize={20} fontWeight={700}>
                          {selectedMember.name_full}
                        </Typography>

                        <Typography color="text.secondary" fontSize={16} sx={{ mt: -0.5 }}>
                          {selectedMember.idjemaat}
                        </Typography>

                        <Typography color="text.secondary" fontSize={15}
                          sx={{
                            mt: -0.5,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {selectedMember.alamat}
                        </Typography>
                      </Box>
                    ) : (
                      <Typography
                        fontSize={18}
                        fontWeight={700}
                        color="text.secondary"
                      >
                        Pilih Anggota
                      </Typography>
                    )}
                  </Stack>
                  <Box sx={{ flexGrow: 1 }} />
                  <IconButton
                    onClick={() => setMemberModalOpen(true)}
                    sx={{
                      width: 36,
                      height: 36,
                      alignSelf: "flex-start",
                      borderRadius: 2,
                      backgroundColor: isDark ? "#1e3a8a" : "#2563eb",
                    }}
                    size="small"
                  >
                    <ContactPageIcon sx={{
                      color: "#fff",
                      fontSize: 20
                    }} />
                  </IconButton>
                </Stack>


              </Grid>



              <Grid item size={{ xs: 12, sm: 12, lg: 4 }}>
                <Paper
                  elevation={2}
                  sx={{
                    p: 1.5,
                    borderRadius: 2,
                    border: "1px solid",
                    borderColor: isDark ? "rgba(255,255,255,0.08)" : "#e2e8f0",
                    background: isDark
                      ? "linear-gradient(145deg, rgba(30,41,59,0.8), rgba(2,6,23,0.8))"
                      : "linear-gradient(145deg, #eef2ff, #ffffff)",
                  }}
                >
                  <Grid container spacing={1} alignItems="center" justifyContent="flex-end">
                    <Grid item>
                      <Typography fontSize={13} color="text.secondary" sx={{ whiteSpace: "nowrap" }}>
                        Terpilih:&nbsp;
                      </Typography>
                      <Stack component="span" direction="row" spacing={1} alignItems="baseline">
                        <Typography fontSize={18} fontWeight={700} sx={{ whiteSpace: "nowrap" }}>
                          {countSelected.toLocaleString()}
                        </Typography>
                        <Typography fontSize={13} color="text.secondary" sx={{ whiteSpace: "nowrap" }}>
                          Record
                        </Typography>
                        <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                        <Typography fontSize={13} color="text.secondary" sx={{ whiteSpace: "nowrap" }}>
                          Total :&nbsp;
                        </Typography>
                        <Typography fontSize={18} fontWeight={700} sx={{ whiteSpace: "nowrap", minWidth: 80 }}>
                          <motion.div
                            key={totalSelected}
                            initial={{ scale: 0.95, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            transition={{ duration: 0.2 }}
                          >
                            {totalSelected.toLocaleString()}
                          </motion.div>

                        </Typography>
                      </Stack>
                    </Grid>

                    <Box sx={{ flexGrow: 1 }} />
                    <Button

                      variant="contained"
                      color="success"
                      disabled={submitting || selectedBills.length === 0}
                      sx={{
                        px: 2,
                        minWidth: 100,
                        fontWeight: 800,
                        borderRadius: 3,
                        letterSpacing: 0.3,
                        boxShadow: "0 8px 18px rgba(22,163,74,0.35)",
                        textTransform: "none",
                        whiteSpace: "nowrap",
                        flexShrink: 0, // 🔥 important
                      }}
                      onClick={handleSubmitPayment}
                    >
                      <SaveIcon sx={{ mr: 1 }} size={24} />
                      {submitting ? "Processing..." : "Submit"}
                    </Button>
                  </Grid>

                </Paper>
              </Grid>




            </Grid>
          </Paper>


        </Grid>

        {/* CONTENT */}
        <Grid item size={{ xs: 12 }} >
          <Paper
            elevation={1}

            sx={{
              p: 2,
              background: isDark
                ? "linear-gradient(145deg, rgba(15,23,42,0.95), rgba(2,6,23,0.98))"
                : "linear-gradient(145deg, #ffffff, #eef2ff)",
              border: "1px solid",
              borderColor: isDark ? "rgba(255,255,255,0.08)" : "#e2e8f0",
              boxShadow: isDark
                ? "0 12px 28px rgba(0,0,0,0.35)"
                : "0 10px 24px rgba(15,23,42,0.08)",
            }}
          >
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography variant="h6" fontWeight={600}>
                Kartu Pembayaran
              </Typography>

              <Box flex={1} />
              <ToggleButton
                value="hide-paid"
                selected={hidden}
                size="small"
                onChange={() => setHidden(!hidden)}
                sx={{
                  height: "25px",
                  borderRadius: 3,
                  textTransform: "none",
                  fontWeight: 500,
                  gap: 1,
                  transition: "0.2s ease",
                  "&.Mui-selected": {
                    backgroundColor: "warning.main",
                    color: "white",
                    "&:hover": {
                      backgroundColor: "warning.dark",
                    },
                  },
                }}
              >
                {hidden ? (
                  <VisibilityOffIcon sx={{ fontSize: 16 }} />
                ) : (
                  <VisibilityIcon sx={{ fontSize: 16 }} />
                )}
                {hidden ? "Unpaid" : "All"}
              </ToggleButton>

              {/* Select All / Clear */}
              <Button
                size="small"
                variant={isAllSelected ? "outlined" : "contained"}
                color="primary"
                onClick={handleToggleSelectAll}
                sx={{
                  height: "25px",
                  borderRadius: 3,
                  textTransform: "none",
                  fontSize: 12,
                  fontWeight: 600,
                  px: 1.5,
                }}
                disabled={visibleUnpaidBills.length === 0}
              >
                {isAllSelected ? "Batal Pilih" : "Pilih Semua"}
              </Button>
            </Stack>
            <Divider sx={{ mt: 2 }} />

            <Box sx={{
              height: {
                xs: "calc(74vh - 140px)",
                md: "calc(74vh - 19px)", // example: header taller on desktop
              },
              overflowY: "auto", mt: 1,

            }}>
              <Stack spacing={1}>
                {bills.map((b) => (
                  <Box
                    key={b.id}
                    sx={{
                      display: hidden && b.ispaid === 1 ? "none" : "block",
                      border: "1px solid",
                      borderColor: isDark ? "rgba(255,255,255,0.08)" : "#e2e8f0",
                      borderRadius: 2,
                      px: 2,
                      py: 1.5,
                      transition: "all .15s ease",
                      "&:hover": {
                        // backgroundColor: "#f9fafb",
                        borderColor: isDark ? "rgba(255,255,255,0.2)" : "#cbd5e1",
                        boxShadow: "0 6px 16px rgba(0,0,0,0.12)",
                        transform: "translateY(-1px)",
                      },
                      "&::before": selectedBills.includes(b.cardcode)
                        ? {
                          content: '""',
                          position: "absolute",
                          left: 0,
                          top: 0,
                          bottom: 0,
                          width: 4,
                          background: "#facc15",
                          borderRadius: "6px 0 0 6px",
                        }
                        : {},
                      position: "relative",

                      background: selectedBills.includes(b.cardcode)
                        ? (isDark
                          ? "linear-gradient(270deg, rgba(15,23,42,0.95) 0%, rgba(30,41,59,0.95) 100%)"
                          : "linear-gradient(270deg, #ffffff 0%, #fff8e6 100%)")
                        : b.ispaid === 1
                          ? (isDark ? "rgba(22,163,74,0.08)" : "#f6fff6")
                          : (isDark ? "rgba(2,6,23,0.65)" : "#fff"),

                    }}
                  >
                    <Stack direction="row" spacing={2} alignItems="center">

                      {/* Checkbox */}
                      <Checkbox
                        checked={selectedBills.includes(b.cardcode)}
                        onChange={() => toggleBill(b.cardcode)}
                        disabled={b.ispaid === 1}
                      // alignSelf="flex-start"
                      />

                      {/* Main Info */}
                      <Box flex={1}>
                        <Typography variant="h6" fontWeight={600}>
                          {getNamaBulan(b.cardmonth)} {b.cardyear}
                        </Typography>

                        <Typography
                          variant="caption"
                          color="text.secondary"
                        >
                          {b.cardcode}
                        </Typography>
                      </Box>

                      {/* Nominal */}
                      <Box textAlign="right" minWidth={140}>
                        <Typography fontWeight={600}>
                          {Number(b.amount).toLocaleString()}
                        </Typography>
                        <Typography
                          variant="caption"
                          color="text.secondary"
                        >
                          Nominal
                        </Typography>
                      </Box>

                      {/* Status */}
                      <Box minWidth={90} textAlign="right">
                        {b.ispaid === 1 ? (
                          <Chip label="Paid" color="success" size="small" />
                        ) : (
                          <Chip label="Unpaid" color="error" size="small" />
                        )}
                      </Box>
                    </Stack>
                  </Box>
                ))}

                {bills.length === 0 && (
                  <Box py={4} textAlign="center">
                    <Stack spacing={2} sx={{ alignItems: 'center' }}>
                      <Typography variant={'h4'} color="text.secondary">
                        Tidak ada tagihan.
                      </Typography>
                      <Stack direction={'row'} spacing={2}
                        sx={{ alignItems: 'center' }}
                      >
                        <Typography fontSize={18} color="text.secondary"
                          sx={{
                            mt: 4,
                          }}>
                          Anda bisa memilih anggota dari tombol
                        </Typography>
                        <Box

                          sx={{
                            alignContent: 'center',
                            alignItems: 'center',
                            width: 36,
                            height: 36,
                            borderRadius: 3,
                            backgroundColor: "#3b79d0",
                          }}
                          size="small"
                        >
                          <ContactPageIcon sx={{
                            color: "#fff",
                            fontSize: 18
                          }} />
                        </Box>
                      </Stack>
                    </Stack>
                  </Box>
                )}
              </Stack>
            </Box>

            {/* Sticky Footer Summary */}
            {/* <Box
              sx={{
                position: "sticky",
                bottom: 0,
                mt: 1.5,
                pt: 1.5,
                background: isDark
                  ? "linear-gradient(180deg, rgba(2,6,23,0), rgba(2,6,23,0.95))"
                  : "linear-gradient(180deg, rgba(248,250,252,0), rgba(248,250,252,0.98))",
              }}
            >
              <Paper
                elevation={0}
                sx={{
                  p: 1.5,
                  borderRadius: 2,
                  border: "1px solid",
                  borderColor: isDark ? "rgba(255,255,255,0.08)" : "#e2e8f0",
                  background: isDark ? "rgba(15,23,42,0.95)" : "#ffffff",
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                <Stack direction="row" spacing={1} alignItems="baseline">
                  <Typography fontSize={13} color="text.secondary">
                    Terpilih
                  </Typography>
                  <Typography fontSize={18} fontWeight={700}>
                    {countSelected.toLocaleString()}
                  </Typography>
                  <Typography fontSize={13} color="text.secondary">
                    Record
                  </Typography>
                </Stack>
                <Divider orientation="vertical" flexItem />
                <Stack direction="row" spacing={1} alignItems="baseline">
                  <Typography fontSize={13} color="text.secondary">
                    Total
                  </Typography>
                  <Typography fontSize={18} fontWeight={700}>
                    {totalSelected.toLocaleString()}
                  </Typography>
                </Stack>
                <Box flex={1} />
                <Button
                  variant="contained"
                  color="success"
                  disabled={submitting || selectedBills.length === 0}
                  sx={{
                    px: 2,
                    minWidth: 120,
                    fontWeight: 800,
                    borderRadius: 3,
                    letterSpacing: 0.3,
                    boxShadow: "0 8px 18px rgba(22,163,74,0.35)",
                    textTransform: "none",
                    whiteSpace: "nowrap",
                    flexShrink: 0,
                  }}
                  onClick={handleSubmitPayment}
                >
                  <SaveIcon sx={{ mr: 1 }} size={24} />
                  {submitting ? "Processing..." : "Submit"}
                </Button>
              </Paper>
            </Box> */}

          </Paper>
        </Grid>
      </Grid>

      {/* Member Picker Modal */}
      <MemberSelectModal
        open={memberModalOpen}
        onClose={() => setMemberModalOpen(false)}
        members={rows}
        onSelect={handleSelectMember}
      />
      <PaymentResponse
        open={payResponModalOpen}
        onClose={() => setPayResponModalOpen(false)}
        data={responPayment}
      />
      <Snackbar
        open={toast.open}
        autoHideDuration={4000}
        onClose={() => setToast((prev) => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={() => setToast((prev) => ({ ...prev, open: false }))}
          severity={toast.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {toast.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}
